import React from 'react'

const InstuctorDetails = () => {
  return (
    <div>InstuctorDetails</div>
  )
}

export default InstuctorDetails